import ServiceLevel from '~/types/ServiceLevel';

export interface JSONCarrier {
  id: string;
  image_filename?: string;
  is_manifestable?: boolean;
  is_manifestable_date_range?: boolean;
  is_refundable?: boolean;
  is_track_substatus_enabled?: boolean;
  live_base_url?: string;
  max_tracking_numbers_allowed?: number;
  name?: string;
  provider_token?: string;
  service_levels?: ServiceLevel[];
  test_base_url?: string;
  track_url?: string;
  updated_time?: Date;
}

type Carrier = {
  id: string;
  providerToken: string;
  name: string;
  img: string;
  img200: Maybe<string>;
  img260: Maybe<string>;
  imgTrademark?: string;
  icon: string;
  isManifestable?: boolean;
  isManifestableDateRange?: boolean;
};

function normalizeCarrierName(name: string): string {
  return name.trim().replace(/\s+/g, '_').toLowerCase();
}

function extraFieldsFromJSON(jsonCarrier: JSONCarrier) {
  const serialized: Partial<Carrier> = {
    providerToken: jsonCarrier.provider_token,
    isManifestable: jsonCarrier.is_manifestable || false,
    isManifestableDateRange: jsonCarrier.is_manifestable_date_range || false,
  };

  return serialized;
}

export { extraFieldsFromJSON, normalizeCarrierName };

export default Carrier;
